import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'md',
  onClick,
  href = 'https://trk.gohealthboost.com/click'
}: CTAButtonProps) {
  const baseStyles = 'bg-[#10b981] hover:bg-[#059669] text-white font-bold uppercase tracking-wide transition-all duration-200 shadow-md hover:shadow-lg hover:scale-[1.02] flex items-center justify-center gap-2 rounded-sm';
  const sizeStyles = {
    sm: 'py-2 px-4 text-xs',
    md: 'py-3 px-6 text-xl',
    lg: 'py-4 px-8 text-xl'
  };
  return <a href={href} className={`${baseStyles} ${sizeStyles[size]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={onClick} data-id="element-11">
      {children}
      <ArrowRight size={size === 'lg' ? 24 : 16} strokeWidth={3} data-id="element-12" />
    </a>;
}